/** Sentinel period for recurring weekly targets (applies to every week unless overridden). */
export const RECURRING_WEEK_PERIOD_TYPE = "week_default" as const;
export const RECURRING_WEEK_PERIOD_START = "1970-01-01";

export function isRecurringWeekTarget(periodType: string, periodStart: string): boolean {
  return periodType === RECURRING_WEEK_PERIOD_TYPE && periodStart === RECURRING_WEEK_PERIOD_START;
}
